<div class="mb-3">
  <label>Operator Name</label>
  <input type="text" class="form-control" [(ngModel)]="operatorName" />
</div>
<fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
